
import { Badge } from '@chakra-ui/react';
import { Edit, Trash2, Settings } from 'lucide-react';
import { TableColumn, TableAction, ActionHandler } from '@/components/section/EntityTableSection';
import { ConditionGroupLookup } from './api';
import RelativeTime from '@/components/ui/RelativeTime';
import OrderBadge from '@/components/ui/OrderBadge';
import { getStatusBadgeProps } from '@/utils/lookupStatus';

// Strongly typed actions for condition groups
export type ConditionGroupAction = 'view' | 'edit' | 'delete' | 'manageConditions';

export const createConditionGroupColumns = (): TableColumn<ConditionGroupLookup>[] => [
  {
    key: "id",
    title: "ID",
    variant: "id",
  },
  {
    key: "name",
    title: "NAME",
    variant: "primary",
  },
  {
    key: "status",
    title: "STATUS",
    render: (group) => {
      const { colorPalette, label } = getStatusBadgeProps(group.status);
      return (
        <Badge colorPalette={colorPalette} size="sm">
          {label}
        </Badge>
      );
    },
  },
  {
    key: "order",
    title: "ORDER",
    render: (group) => (
      <OrderBadge value={group.order} />
    ),
  },
  {
    key: "created",
    title: "CREATED",
    render: (group) => (
      <RelativeTime date={group.created_at} />
    ),
  },
  {
    key: "updated",
    title: "UPDATED",
    render: (group) => (
      <RelativeTime date={group.updated_at} fallbackDate={group.created_at} />
    ),
  },
];

export const createConditionGroupActions = (
  onAction: ActionHandler<ConditionGroupLookup, ConditionGroupAction>,
  isLoading: boolean
): TableAction<ConditionGroupLookup>[] => [
  {
    key: "edit",
    label: "Edit",
    icon: Edit,
    onClick: (entity) => onAction("edit", entity),
    disabled: isLoading,
  },
  {
    key: "manageConditions",
    label: "Manage Conditions",
    icon: Settings,
    onClick: (entity) => onAction("manageConditions", entity),
    disabled: isLoading,
            colorPalette: "blue",
  },
  {
    key: "delete",
    label: "Delete",
    icon: Trash2,
    onClick: (entity) => onAction("delete", entity),
    disabled: isLoading,
            colorPalette: "red",
  },
]; 